export const environment = {
  production: false,
  name: 'development',
  configFilePath: 'assets/app.config.development.json',
};
